/**
 * External dependencies
 */

import { TouchableOpacity, Text, Linking } from 'react-native';

/**
 * GeChiUI dependencies
 */
import { __ } from '@gechiui/i18n';
import { external, Icon } from '@gechiui/icons';

export function ExternalLink( { href, children } ) {
	return (
		<TouchableOpacity
			onPress={ () => Linking.openURL( href ) }
			accessibilityLabel={ __( 'Open link in a browser' ) }
		>
			<Text>{ children }</Text>
			<Icon icon={ external } />
		</TouchableOpacity>
	);
}

export default ExternalLink;
